module.exports = __webpack_public_path__ + "img/landkarte.28ddd82f.png";